import request from "./config";
export default class EntityService {
  static list(query = {}) {
    return request({
      url: "/entity",
      method: "get",
      timeout: 10000,
      params: query,
    });
  }
  static searchDocument(params = {}) {
    return request({
      url: "/entity/document-search",
      method: "get",
      timeout: 10000,
      params,
    });
  }
  static create(data){
    return request({
      url: "/entity",
      method: "post",
      timeout: 100000,
      data,
    });
  }
  static delete(data){
    return request({
      url: `/entity/delete/${data.id}`,// /api
      method: "delete",
      timeout: 100000,
    });
  }
  static update(id,data){
    return request({
      url: "/entity/"+id,
      method: "put",
      timeout: 100000,
      data,
    });
  }
}
